import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as lineSelectors, actions as lineActions } from 'ducks/salesInvoiceEnquiry/InvoiceSalesAudit';
import { fetch } from 'api/salesInvoiceEnquiry/invoiceSalesAudit';
import { selectors as invoiceSelectors } from 'ducks/salesInvoiceEnquiry/Invoice';
const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'SalesAudit',
  columnDefs: lineSelectors.lineColumns(state),
  rowData: lineSelectors.lines(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
  gridOptions: lineSelectors.gridOptions(state),
  isLoading: lineSelectors.isLoading(state),
  keyFields: [{ valueField: 'SalesauditregId', routeField: 'AuditRegId' }],
  reqParams: (invoiceSelectors.selected(state) || params.get('InvoiceNumber') || params.get('SalesEntity'))
    &&
  {
    Invoice: (invoiceSelectors.selected(state) && invoiceSelectors.selected(state).Invoice) || params.get('InvoiceNumber'),
    SalesEntity: (invoiceSelectors.selected(state) && invoiceSelectors.selected(state).SalesEntity) || params.get('SalesEntity'),
  },
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: lineActions.setSelected
}
